import { useState, useCallback, useEffect, useRef } from 'react';
import { Container, Content, LoadSpin, RenderVideo } from './styled';
import VisibilitySensor from 'react-visibility-sensor';
import { Footer } from '../../components';
import { getVideo } from '../../../../service/serviceChat/chatService';
import { MdSlowMotionVideo } from 'react-icons/md';
import { FiDownload } from 'react-icons/fi';
import { IoIosVideocam } from 'react-icons/io';
import { BsPlayFill, BsPauseFill } from 'react-icons/bs';
import { CgInpicture } from 'react-icons/cg';
import moment from 'moment';

export function Video(props) {


    const { message, className } = props;

    const refVideo = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [url, setUrl] = useState('');
    const [automaticLoading, setAutomaticLoading] = useState(true);
    const [isRendered, setIsRendered] = useState(false);
    const [maxWidth, setMaxWidth] = useState(0);
    const [controls, setControls] = useState(false);

    useEffect(() => {
        if (refVideo.current === null) return
        setMaxWidth(refVideo.current.width)
    }, [isRendered])
    const searchUrl = useCallback(async (message) => {
        setIsLoading(true);
        const video = await getVideo(message?.id_video);
        setUrl(video?.url);
        setIsLoading(false);
        setAutomaticLoading(false);
        return
    }, [])
    const onSearchUrl = (isVisible) => {
        if (!isVisible || url) return;
        searchUrl(message);
    }



    function handlePlay() {
        if (refVideo.current) {
            refVideo.current.play();
        }

    }
    function handlePause() {
        if (refVideo.current) {
            refVideo.current.pause();
        }
    }


    function handlePictureInPicture() {
        if (refVideo.current.pictureInPictureElement) {
            document.exitPictureInPicture()
        } else {
            refVideo.current.requestPictureInPicture();
            handlePlay()
        }
    }

    function handleDownload() {
        function download(url, filename) {
            fetch(url)
                .then(response => response.blob())
                .then(blob => {
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = filename;
                    link.click();
                })
                .catch(console.error);
        }
        download(url, `webChat4u - ${moment(new Date()).format('DD-MM-yyyy HH:mm')}`)
    }



    return (
        <Container
            isUserSystem={message?.user_system ? true : false}
            className={className}
            maxWidth={maxWidth > 0 ? maxWidth : false}
        >
            {automaticLoading
                ? <VisibilitySensor onChange={(isVisible) => { onSearchUrl(isVisible) }}>
                    <div className='skeleton--box'>
                        <IoIosVideocam className='icon--' />
                        <span className='skeleton'></span>
                    </div>
                </VisibilitySensor>
                : <Content isRenderedVideo={isRendered} maxWidth={maxWidth > 0 ? maxWidth : false}>
                    {!isRendered &&
                        <div className='loading__'>
                            <span className='refresh__'>
                                {!url &&
                                    <>
                                        {!isLoading
                                            ? <MdSlowMotionVideo onClick={() => searchUrl(message)} />
                                            : <LoadSpin />
                                        }
                                    </>
                                }
                            </span>
                        </div>
                    }
                    {isRendered &&
                        <span className='actions__'>
                            <CgInpicture className='icon--' onClick={() => handlePictureInPicture()} />
                            <FiDownload className='icon--' onClick={() => handleDownload()} />
                        </span>
                    }
                    {url &&
                        <RenderVideo isRenderedVideo={isRendered} >
                            <div className={`controls ${controls && 'isVisibility'}`}>
                                {!controls
                                    ? (<BsPlayFill
                                        onClick={() => handlePlay()
                                        }
                                    />)
                                    : (<BsPauseFill
                                        onClick={() => handlePause()}
                                    />)
                                }
                            </div>
                            <video
                                controls={controls}
                                ref={refVideo}
                                onLoadedData={() => {
                                    setIsRendered(true);
                                }}
                                onPlay={() => {
                                    setControls(true)
                                }}
                                onPause={() => {
                                    setControls(false)
                                }}
                                onEnded={() => {
                                    setControls(false);
                                }}
                            >
                                <source src={url} type="video/mp4" />
                            </video>
                        </RenderVideo>
                    }

                </Content>
            }
            {message?.body &&
                <p>
                    {message?.body}
                </p>
            }
            <div className={`${!message?.body ? 'footer-styled' : ''}`}>
                <Footer message={message} />
            </div>
        </Container>
    )
}